import { dialogProps as s } from "./ghl-ui.es982.js";
import { cardBaseProps as o } from "./ghl-ui.es187.js";
import { keysOf as r } from "./ghl-ui.es924.js";
const e = Object.assign(Object.assign({}, o), s), m = r(e);
export {
  e as presetProps,
  m as presetPropsKeys
};
